<template>
    <div v-bind:class="applied_calendar_css" class="notranslate" tabindex="0">
        <input v-if="!(mode=='static')"
               type="text"
               v-bind:name ="text_input_name"
               v-bind:value="selectedDateString" v-on:input="onTextChanged($event)"
               v-bind:class="[inputClass, errorClass]"
               v-on:keyup.up="move('up')" v-on:keyup.down="move('down')"
               v-on:keyup.enter="onEnter($event)" v-on:keydown.enter="$event.preventDefault()"
               v-on:blur="onFocusout($event)"
               v-on:click="onFocus()"
               v-bind:disabled="disabled ? '' : null"
               autocomplete="one-time-code" />
        <div class="list-container" v-bind:class="{'hidden': calendar_visible}">
            <div class="calendar-content" v-on:mousedown="$event.preventDefault()">
                <table class="calendar-table" style="background-color:#fff">
                    <thead>
                        <tr>
                            <th class="month-cell" colspan="5">{{currentMonth.getFullYear()}}  {{currentMonth.toLocaleString(locale, { month: "long" })}}</th>
                            <th class="nav-cell" v-on:mousedown="navMonth($event, -1)">&lt;</th>
                            <th class="nav-cell" v-on:mousedown="navMonth($event, 1)">&gt;</th>
                        </tr>
                        <tr>
                            <th class="week-cell" v-for="(weekday, index) in weekdays" v-bind:key="index">
                                {{weekday}}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="days.length > 0">
                        <tr v-for="(row, rowIndex) in 6" v-bind:key="rowIndex">
                            <td v-for="(day, index) in days.slice(rowIndex*7, (rowIndex+1)*7)" v-bind:key="index" v-on:mousedown="selectDay(day)" class="date-cell" v-bind:class="day.css_class_list">
                                <p class="date-cell-header">{{day.date.getDate()}}</p>
                                <div class="date-cell-body">
                                    <slot name="date_cell" v-bind:visible-data="getDateString(day)"></slot>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ul class="n2-valid" v-bind:class="{'n2-errors':errors}">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
    </div>
</template>
<script>

    export default {
        name: 'app-calendar',
        props: ['locale', 'label', 'text_input_name', 'value', 'valid_dates', 'selected_dates', 'calendar_css', 'dates_css', 'sunday_css', 'saturday_css', 'min_date', 'max_date', 'disabled', 'css_class', 'errors', 'before_date_show', 'mode', 'initial_month'],
        data: function () {
            return {
                view_month: null,
                userText: '',
                hiddenList: true,
                inputClass: this.css_class ? this.css_class : 'n2-input-default',
            };
        },
        computed: {
            applied_calendar_css: function () {
                return this.calendar_css ? this.calendar_css : 'n2-calendar';
            },
            calendar_visible: function () {
                return this.mode == 'static' ? false : this.hiddenList;
            },
            errorClass: function () {
                return this.errors ? 'n2-invalid-field' : '';
            },
            selectedDateString: {
                get() {
                    if (this.value) {
                        let array = this.value.split('-');
                        switch (this.locale) {
                            case 'nb-NO':
                            case "nn-NO":
                            case "no":
                                return array[2] + '.' + array[1] + '.' + array[0];
                            default:
                                return parseInt(array[1]) + '/' + parseInt(array[2]) + '/' + array[0];
                        }

                    }
                    return '';
                },
                set(val) {
                    this.userText = val;
                }
            },

            currentMonth: function () {
                if (this.view_month) {
                    return new Date(this.view_month);
                }
                else if (this.initial_month) {
                    return new Date(`${this.initial_month.substr(0, 7)}-01`);
                }
                else if (this.value) {
                    return new Date(this.value);
                }
                else {
                    let curDate = new Date();
                    return new Date(Date.UTC(curDate.getFullYear(), curDate.getMonth(), curDate.getDate()));
                }
            },
            weekdays: function () {
                switch (this.locale) {
                    case 'nb-NO':
                    case "nn-NO":
                    case "no":
                        return ['ma', 'ti', 'on', 'to', 'fr', 'lø', 'sø'];
                    default:
                        return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
                }
            },
            firstWeekDay: function () {
                switch (this.locale) {
                    case 'nb-NO':
                    case "nn-NO":
                    case "no":
                        return 'MONDAY';
                    default:
                        return 'SUNDAY';
                }
            },

            days: function () {
                var currentDay = new Date(Date.UTC(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1));
                let preDays = currentDay.getDay();
                if (this.firstWeekDay === 'MONDAY') {
                    preDays -= 1;
                    if (preDays < 0) {
                        preDays = 6;
                    }
                }
                currentDay.setDate(currentDay.getDate() - preDays);

                currentDay = new Date(Date.UTC(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate()));

                let list = [];
                let dateNow = new Date();
                for (let i = 0; i < 42; i++) {
                    let isToday = false;
                    let isSelected = false;

                    if (currentDay.getTime() == new Date(Date.UTC(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())).getTime()) {
                        isToday = true;
                    }
                    let currentISODate = currentDay.toISOString().split('T')[0];
                    if (this.value == currentISODate) {
                        isSelected = true;
                    }


                    //css
                    let csslist = [];
                    if (isSelected) {
                        csslist.push('selected');
                    }
                    if (isToday) {
                        csslist.push('today');
                    }

                    if (currentDay.getDay() == 0 && this.sunday_css) {
                        csslist.push(this.sunday_css)
                    }

                    if (currentDay.getDay() == 6 && this.saturday_css) {
                        csslist.push(this.saturday_css)
                    }
                    if (this.dates_css) {
                        this.dates_css.forEach(dc => {
                            if (dc.date == currentISODate) {
                                csslist.push(dc.css)
                            }
                        })
                    }

                    if (this.before_date_show) {
                        let dayData = this.before_date_show(currentISODate);
                        if (dayData) {
                            if (dayData.css_class) {
                                csslist = [...csslist, ...dayData.css_class.split(' ')];
                            }
                        }
                    }

                    //last css
                    let valid = this.validateDate(currentISODate);
                    if (valid) {
                        if (!csslist.includes('valid-date')) {
                            csslist.push('valid-date');
                        }
                    }
                    else {
                        if (!csslist.includes('invalid-date')) {
                            csslist.push('invalid-date');
                        }
                    }
                    if (this.selected_dates) {
                        let selected = this.selected_dates.includes(currentISODate);
                        if (selected) {
                            if (!csslist.includes('selected-date')) {
                                csslist.push('selected-date');
                            }
                        }
                    }
                    ////////////////////////////////
                    list.push({
                        date: new Date(currentDay),
                        data: {
                            valid: valid
                        },
                        css_class_list: csslist
                    });
                    currentDay.setDate(currentDay.getDate() + 1);
                    currentDay = new Date(Date.UTC(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate()));

                }
                return list;
            }

        },
        watch: {
            value: function (val) {
                if (val) {
                    let testDate = new Date(val);
                    let testArray = val.split('-');
                    if ((testDate.getFullYear() != parseInt(testArray[0]))
                        || (testDate.getMonth() + 1 != parseInt(testArray[1]))
                        || (testDate.getDate() != parseInt(testArray[2]))
                        || !this.validateDate(val)
                    ) {
                        this.$emit('input', '');
                    }
                    else {
                        this.userText = this.selectedDateString;
                    }
                }
            },
            min_date:function(val){
                if(val){
                    let dateNow = new Date();
                    let currentDay = new Date(Date.UTC(dateNow.getFullYear(), dateNow.getMonth(), 1));

                    
                    let minDay = new Date(val);
                    let minMonth = new Date(Date.UTC(minDay.getFullYear(), minDay.getMonth(), 1));

                    if(minMonth>currentDay){
                        this.view_month = minDay;
                    }
                    else{
                        if(!this.value){
                            this.view_month = currentDay;
                        }
                    }
                }
            }
        },
        methods: {
            getDateString: function (day) {
                return day.date.toISOString().split('T')[0];
            },
            validateDate: function (currentISODate) {
                let valid = true;
                let currentDay = new Date(currentISODate);
                if (this.before_date_show) {
                    let dayData = this.before_date_show(currentISODate);
                    if (dayData) {
                        if (dayData.valid != undefined) {
                            if (!dayData.valid) {
                                valid = false;
                            }
                        }
                    }
                }

                //min max
                if (this.min_date) {
                    let minDate = new Date(this.min_date);
                    if (currentDay < minDate) {
                        valid = false;
                    }
                }
                if (this.max_date) {
                    let maxDate = new Date(this.max_date);
                    if (currentDay > maxDate) {
                        valid = false;
                    }
                }
                if (this.valid_dates && !this.valid_dates.includes(currentISODate)) {
                    valid = false;
                }
                return valid;
            },
            navMonth: function (e, mon) {
                let month = new Date(Date.UTC(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1));
                month.setMonth(month.getMonth() + mon);
                this.view_month = month;
            },
            selectDay: function (day) {
                if (day.data.valid) {
                    this.userText = this.selectedDateString;
                    this.hiddenList = true;
                    this.$emit('input', day.date.toISOString().split('T')[0]);
                    this.$emit('selected', day.date.toISOString().split('T')[0]);
                }
            },
            onFocus: function () {
                this.hiddenList = false;
            },
            onFocusout: function () {
                this.hiddenList = true;

                if (!this.parseToIsoDate(this.userText)) {
                    this.userText = '';
                    this.$emit('input', '');
                }
            },
            onEnter: function () {
            },
            move: function () {
            },
            onTextChanged: function ($event) {
                this.userText = $event.target.value;
                let isoDate = this.parseToIsoDate($event.target.value);
                if (isoDate) {
                    this.view_month = new Date(isoDate);
                    this.$emit('input', isoDate);
                }
            },
            parseToIsoDate: function (text) {
                let isoDate = '';
                try {
                    switch (this.locale) {
                        case 'nb-NO':
                        case "nn-NO":
                        case "no":
                            if (text.length == 10) {
                                let noArroay = text.split('.');
                                if (noArroay.length == 3 && noArroay[2].length == 4) {
                                    isoDate = text.split('.').reverse().join('-');
                                }
                            }
                            break;
                        default:
                            if (text.length >= 8 && text.length <= 10) {
                                let dArroay = text.split('/');
                                if (dArroay.length == 3 && dArroay[2].length == 4) {
                                    isoDate = parseInt(dArroay[2])
                                        + '-' + (parseInt(dArroay[0]) < 10 ? '0' + parseInt(dArroay[0]) : parseInt(dArroay[0]))
                                        + '-' + (parseInt(dArroay[1]) < 10 ? '0' + parseInt(dArroay[1]) : parseInt(dArroay[1]));
                                }
                            }
                    }
                    if (isoDate) {
                        let testDate = new Date(isoDate);
                        let testArray = isoDate.split('-');
                        if ((testDate.getFullYear() != parseInt(testArray[0]))
                            || (testDate.getMonth() + 1 != parseInt(testArray[1]))
                            || (testDate.getDate() != parseInt(testArray[2]))
                        ) {
                            return '';
                        }
                        else {
                            return isoDate;
                        }
                    }
                }
                catch (e) {
                    console.log(e)
                }
                return '';
            }
        }
    }
</script>
<style lang="sass">
</style>
